import axios from 'axios';
import get from 'lodash/get';
import {
  handleErrorWithPromise,
} from './axios.service';

const { CancelToken } = axios;

export const postFormDataSource = CancelToken.source();
export const postFormData = (
    data = {},
    endpoint = 'offer'
) => {
    const dealerId = get(window, 'MLB_FORM_CONFIG.dealer', false) || false;
    const requestData = dealerId ? {
        ...data,
        dealerId
    } : data;
  return axios
    .request({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/form/${endpoint}`,
      data: requestData,
      cancelToken: postFormDataSource.token,
    })
    .catch(handleErrorWithPromise());
};

export const fetchModelsDataSource = CancelToken.source();
export const fetchModels = () =>
    axios.request({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/models`,
      cancelToken: fetchModelsDataSource.token
    })
    .catch(handleErrorWithPromise());